import { useExpenses } from "@/contexts/expense-context";
import { ExpenseCard } from "@/components/expense-card";
import { BottomNav } from "@/components/bottom-nav";
import { ListSkeleton } from "@/components/skeleton";
import { useMemo } from "react";

export default function ExpensesPage() {
    const { expenses, loading, error } = useExpenses();

    const sortedExpenses = useMemo(() => {
        return [...expenses].sort(
            (a, b) =>
                new Date(b.date).getTime() - new Date(a.date).getTime()
        );
    }, [expenses]);

    return (
        <div className="min-h-screen bg-gray-50 pb-20">
            {/* Header */}
            <div className="bg-white border-b border-gray-200">
                <div className="max-w-4xl mx-auto px-4 py-6">
                    <h1 className="text-3xl font-bold text-gray-900">All Expenses</h1>
                    <p className="text-gray-600 mt-1">
                        {loading ? "Loading..." : `${sortedExpenses.length} expense${sortedExpenses.length !== 1 ? "s" : ""}`}
                    </p>
                </div>
            </div>

            {/* Error Message */}
            {error && (
                <div className="max-w-4xl mx-auto px-4 pt-4">
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                        {error}
                    </div>
                </div>
            )}

            {/* Expenses List */}
            <div className="max-w-4xl mx-auto px-4 py-8">
                <div className="space-y-3">
                    {loading ? (
                        <ListSkeleton count={5} />
                    ) : sortedExpenses.length > 0 ? (
                        sortedExpenses.map((expense) => (
                            <ExpenseCard key={expense.id} expense={expense} />
                        ))
                    ) : (
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
                            <p className="text-gray-500">No expenses yet.</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Bottom Navigation */}
            <BottomNav />
        </div>
    );
}
